import 'TimelineLite';
import 'waypoints/lib/noframework.waypoints';
import Environment from 'common/utils/environment';
import NewsHeadline from 'show-page/components/news-headline';
import SharingLinks from 'common/components/sharing-links';
import ShowHero from 'show-page/components/show-hero';
import styles from './styles.less';
import VideoHero from 'show-page/components/video-hero';
import { findDOMNode } from 'react-dom';
import { get } from 'lodash';
import { observer } from 'mobx-react';
import { reaction } from 'mobx';


@observer(['adManager', 'cvpAuthStore', 'showStore', 'uiStore'])
class ShowHeader extends React.Component {
    static propTypes = {
        params: React.PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            isAuthenticated: props.cvpAuthStore.isAuthenticated,
            viewportWidth: props.uiStore.viewportWidth
        };
    }

    componentWillMount() {
        this.authStateListener = reaction(
            () => this.props.cvpAuthStore.isAuthenticated,
            (isAuthenticated) => this.setState({ isAuthenticated }),
            true
        );
        this.viewportStateListener = reaction(
            () => this.props.uiStore.viewportWidth,
            (viewportWidth) => this.setState({ viewportWidth }),
            true
        );
    }

    componentDidMount() {
        this.createTimeline();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.viewportWidth !== this.state.viewportWidth || prevState.isAuthenticated !== this.state.isAuthenticated) {
            this.createTimeline();
        }
        if (prevProps.params.video !== this.props.params.video) {
            this.runTimeline();
        }
    }

    componentWillUnmount() {
        this.authStateListener();
        this.authStateListener = null;
        this.viewportStateListener();
        this.viewportStateListener = null;
        this.destroyWaypoint();
        this.tL.clear();
        this.tL = null;
    }

    render() {
        const { selectedVideo } = this.props.showStore;
        const className = cx(styles.root, this.props.className, {
            [styles.hasVideo]: selectedVideo
        });
        return (
            <div className={ className }>
                { this.renderHeroContainer() }
                { this.renderMetaRow() }
                { this.renderNewHeadline() }
            </div>
        );
    }

    renderHeroContainer() {
        const { adType } = this.props.adManager;
        const { providerInfo, token } = this.props.cvpAuthStore;
        const { showStickyPlayer } = this.props.uiStore
        const { showStore } = this.props;
        return (
            <div
                className={ styles.heroContainer }
                ref='heroContainer'
                style={{
                    backgroundColor: (showStore.selectedVideo && showStickyPlayer) ? 'transparent' : showStore.highlightColor,
                    color: showStore.rolloverTextColor
                }}>
                <ShowHero
                    ref='showHero'
                    className={ styles.showHero }
                    image={ showStore.heroImage }
                    imageAlignment={ showStore.heroAlignment }
                    showRating={ showStore.collection.tvRating }
                    showTitle={ showStore.title }
                    trailer={ showStore.trailer }
                    visible={ !showStore.selectedVideo }
                />
                <VideoHero
                    ref='videoHero'
                    adType={ adType }
                    backgroundColor={ showStore.highlightColor }
                    className={ styles.videoHero }
                    onTVERequestLogout={ this.handleTVELogout }
                    metadataProps={{
                        backgroundColor: showStore.highlightColor,
                        color: showStore.rolloverTextColor
                    }}
                    playerProps={{
                        onAdComplete: this.handleAdComplete,
                        onAdStart: this.handleAdStart,
                        onExpiredSlateCountdown: this.handleExpiredSlateCountdown,
                        onTVERequestLogin: this.handleTVELogin,
                        onVideoFinished: this.handleVideoFinished,
                        tveAccessToken: token
                    }}
                    showType={ showStore.type }
                    useASPlayer={ showStore.useASPlayer }
                    sticky={ showStickyPlayer }
                    tveProvider={ providerInfo }
                    video={ showStore.selectedVideo }
                />
            </div>
        );
    }

    renderMetaRow() {
        return (
            <div className={ styles.meta }>
                { !!get(this.props.showStore, 'nextShowing.datetime') &&
                <div className={ styles.nextShowing }>
                    Next Showing: { this.props.showStore.nextShowing.datetime }
                </div> }
                <SharingLinks
                    className={ styles.sharingLinks }
                    url={ this.props.showStore.shareUrl }
                />
            </div>
        );
    }

    renderNewHeadline() {
        if (!this.props.showStore.news) return null;
        return (
            <NewsHeadline
                newsHeadline={ this.props.showStore.news }
                className={ styles.newsHeadline }
            />
        );
    }

    createTimeline() {
        const $showHero = findDOMNode(this.refs.showHero);
        const $videoHero = findDOMNode(this.refs.videoHero);
        this.tL = this.tL || new TimelineLite({ onStart: this.destroyWaypoint, onComplete: this.setWaypoint });
        this.tL.clear();
        this.tL
            .addLabel('atShowHero')
            .set($showHero, { clearProps: 'height' })
            .fromTo($showHero, 0.6, { opacity: 1 }, { opacity: 0 })
            .to($showHero, 0.6, { height: 0 })
            .from($videoHero, 0.6, { height: 0, clearProps: 'height' }, '-=0.6')
            .fromTo($videoHero, 0.6, { opacity: 0 }, { opacity: 1 })
            .addLabel('atVideoHero');
        if (this.props.showStore.selectedVideo) {
            this.tL.seek('atVideoHero').pause();
            this.setWaypoint();
        } else {
            this.tL.seek('atShowHero').pause();
            this.destroyWaypoint();
        }
    }

    destroyWaypoint = () => {
        const $heroContainer = findDOMNode(this.refs.heroContainer);
        if ($heroContainer) {
            $heroContainer.style.removeProperty('height');
        }
        if (this.stickyWaypoint) {
            this.stickyWaypoint.destroy();
        }
        this.stickyWaypoint = null;
        this.props.uiStore.setStickyPlayerState(false);
    };

    runTimeline() {
        if (!this.tL) return;
        if (this.props.params.video) {
            this.tL.play();
        } else {
            this.tL.reverse();
        }
    }

    setWaypoint = () => {
        if (Environment.mobile || !Modernizr.mq('(min-device-width:1025px)')) {
            return;
        }
        const { stickyPlayerHeight } = this.props.uiStore;
        const $heroContainer = findDOMNode(this.refs.heroContainer);
        const { height, top } = $heroContainer.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const offset = ((top + scrollTop) + (height - stickyPlayerHeight)) * -1;
        this.props.uiStore.setStickyPlayerOffset(offset);
        this.destroyWaypoint();
        if (this.props.showStore.selectedVideo) {
            this.stickyWaypoint = new Waypoint({
                element: document.body,
                handler: this.handleStickyWaypoint,
                offset
            });
        }
    };

    handleAdStart = (video, eventData) => {
        this.props.adManager.setPlayerAdState(true, eventData);
    };

    handleAdComplete = (video, eventData) => {
        this.props.adManager.setPlayerAdState(false, eventData);
    };

    handleExpiredSlateCountdown = () => {
        if (this.props.showStore.nextVideo) {
            this.props.showStore.playNextVideo();
        } else {
            this.props.showStore.gotoLanding();
        }
    };

    handleStickyWaypoint = (direction) => {
        const $heroContainer = findDOMNode(this.refs.heroContainer);
        if (direction === 'down') {
            const { height } = $heroContainer.getBoundingClientRect();
            $heroContainer.style.setProperty('height', `${height}px`);
        } else {
            $heroContainer.style.removeProperty('height');
        }
        this.props.uiStore.setStickyPlayerState(direction === 'down');
    };

    handleTVELogin = () => {
        this.props.cvpAuthStore.login();
    };

    handleTVELogout = () => {
        this.props.cvpAuthStore.logout();
        this.props.showStore.gotoLanding();
    };

    handleVideoFinished = (video, eventData) => {
        if (this.props.showStore.nextVideo) {
            this.props.adManager.setPlayerAdState(true, eventData);
            this.props.showStore.playNextVideo();
        } else {
            this.props.adManager.setPlayerAdState(false, eventData);
        }
    };

}


export default ShowHeader;



// WEBPACK FOOTER //
// ./src/show-page/containers/show-header/index.js